import dayjs from 'dayjs';

import { DATE_FORMAT } from '@/constants/date.constants';
import { PRODUCTS } from '@/constants/products.constants';
import type { ProductDTO } from '@/pages/Organizations';

export const EMPTY_PRODUCT: ProductDTO = {
  id: -1,
  active: false,
  created_at: '',
  updated_at: '',
  archive_retention: '',
  code: '',
  end_date: dayjs().add(1, 'year').format(DATE_FORMAT),
  retention: '',
  sf_product_id: '',
  start_date: dayjs().format(DATE_FORMAT),
  subscription_limit: 100,
  subscription_unit: 'GB/Day',
  sub_type: '',
  product_type: PRODUCTS.LOG,
  product_name: '',
  organization_id: 0,
  salesforce_organization_id: 0
};

export const PRODUCT_TYPE_DEFAULTS: Record<
  string,
  { unit: string; code: string; name: string }
> = {
  LOG: { unit: 'GB/Day', name: 'Log: Total GB/Day', code: 'POND-LOG' },
  LOG_USER: {
    unit: 'Users',
    name: 'Log: Microsoft 365 - Detection and Response',
    code: 'LOG-O365'
  },
  LOG_KANATI: {
    unit: 'Users',
    name: 'Log: Kanati',
    code: 'LOG-KANATI'
  },
  EDR: { unit: 'Endpoints', name: 'EDR: ...', code: 'POND-EDR' },
  NET: { unit: 'Mbps', name: 'MDR: Network', code: 'POND-NET' },
  RET: {
    unit: '',
    name: 'Log: 90/365 Days - Retention',
    code: 'POND-LOG-X-90365'
  },
  VMP: {
    unit: 'IPs',
    name: 'VMP: Vulnerability Management Platform',
    code: 'POND-VMP'
  },
  VMPE: {
    unit: 'Assets',
    name: 'EVMP: Enhanced Vulnerability Management Platform',
    code: 'POND-VMP-E'
  }
};
